import {
  AlignLFilled,
  ContractLined,
  DocListLined,
  ItemListFilled,
  UsersFilled,
  UsersLined,
  IndentLLined,
} from '@tag/tag-icons';

import styles from './tile.module.scss';
import { Forms } from '@/graphql/contracts/_generated_/contracts';
import { SearchPageNames } from '@/config/pageForms.config';

export type IconType = Record<Forms, JSX.Element>;

const icons: IconType = {
  [Forms.Contracts]: <ContractLined accent="purple" />,
  [Forms.ContractsBC]: <ContractLined accent="purple" />,
  [Forms.Billing]: <DocListLined accent="purple" />,
  [Forms.BillingCycles]: <DocListLined accent='purple' />,
  [Forms.Customers]: <UsersLined accent="purple" />,
  [Forms.CustomersLookup]: <UsersFilled accent="purple" />,
  [Forms.Products]: <DocListLined accent="purple" />,
  [Forms.Uplifts]: <DocListLined accent='purple' />,
  [Forms.ClientDatabases]: <DocListLined accent='purple' />,
  [Forms.BillingByBillingCycles]: <DocListLined accent="purple" />,
  [Forms.PurchaseOrders]: <ItemListFilled accent="purple" />,
  [Forms.ContractLines]: <AlignLFilled accent="purple" />,
  [Forms.ContractDetailsSalesOrdersByBc]: <AlignLFilled accent="purple" />,
  [Forms.ContractDetailsSalesOrders]: <AlignLFilled accent="purple" />,
  [Forms.Bundles]: <IndentLLined accent="purple" />,
};

export interface TileProps {
  searchPage: Forms;
  title: string;
  onClick: (e: any) => void;
}

function Tile({ searchPage, title, onClick }: TileProps) {
  return (
    <div className={styles['tile-container']}>
      <div className={styles.header}>
        <span className={styles.icon}>{icons[searchPage]}</span>
      </div>

      <div className={styles.content} onClick={onClick}>
        <div className={styles.link}>{title}</div>
        <div className={styles.name}>{SearchPageNames[searchPage]} page</div>
      </div>
    </div>
  );
}

export default Tile;
